module.exports = __webpack_public_path__ + "static/media/home.cb3d2cc1.svg";